interface Scripts {
    name: string;
    src: string;
}
export const ScriptStore: Scripts[] = [
    {name: 'vendor', src: '../assets/js/vendor.js'},
    {name: 'app', src: '../assets/js/app.js'},
    {name: 'dataTables', src: '../assets/js/jquery.dataTables.min.js'}
];
